export const FETCH_OPEN_TEMPLATE_FOLDER_OPEN = 'FETCH_OPEN_TEMPLATE_FOLDER_OPEN'
export const FETCH_CLOSE_TEMPLATE_FOLDER_CLOSE = 'FETCH_CLOSE_TEMPLATE_FOLDER_CLOSE'

